import * as Sentry from '@sentry/react';
import { Route, Routes as ReactRouterRoutes } from 'react-router';
import * as URLS from '../constants/URLS.const';
import { DashboardRoutes } from './DashboardRoutes';
import { AuthenticationRoutes } from './AuthenticationRoutes';
import { ProtectedRoute } from './ProtectedRoute';
import { Suspense } from 'react';
import { OrderResultContainer } from '@src/containers';

const SentryRoutes = Sentry.withSentryReactRouterV6Routing(ReactRouterRoutes);

export function Routes() {
  return (
    <SentryRoutes>
      <Route path={`${URLS.ROOT}*`} element={<AuthenticationRoutes />} />
      <Route element={<ProtectedRoute />}>
        <Route
          path={URLS.ROUTE_ORDER_RESULT_BASE_URL}
          element={
            <Suspense fallback={null}>
              <OrderResultContainer />
            </Suspense>
          }
        />
      </Route>
      <Route element={<ProtectedRoute />}>
        <Route path={`${URLS.DASHBOARD_URL}/*`} element={<DashboardRoutes />} />
        <Route path={'*'} element={<DashboardRoutes />} />
      </Route>
    </SentryRoutes>
  );
}
